// 官网
export default [{ // 新闻资讯
    path: '/newsAndInformation',
    name: 'newsAndInformation',
    component: resolve => require(['@/views/website/newsAndInformation/newsAndInformation.vue'], resolve),
    meta: {
        group: "/newsAndInformation",
        isLoginAuthority: true // 需要登录权限才能访问
    }
}, { // 新增新闻资讯
    path: '/addNewsAndInformation',
    name: 'addNewsAndInformation',
    component: resolve => require(['@/views/website/newsAndInformation/addNewsAndInformation.vue'], resolve),
    meta: {
        group: "/newsAndInformation",
        isLoginAuthority: true // 需要登录权限才能访问
    }
}, { // 编辑新闻资讯
    path: '/editNewsAndInformation',
    name: 'editNewsAndInformation',
    component: resolve => require(['@/views/website/newsAndInformation/addNewsAndInformation.vue'], resolve),
    meta: {
        group: "/newsAndInformation",
        isLoginAuthority: true // 需要登录权限才能访问
    }
}]


// WEBPACK FOOTER //
// ./src/router/website/website.js